export function createObjectWithSubKeys(path: string, deepLevelValue: any) {
  const keys = path.split('.').reverse();

  return keys.reduce(
    (accumulator, currentValue) => ({ [currentValue]: accumulator }),
    deepLevelValue
  );
}
